import { translate } from "app/filters/i18nFilter";

import { StyledFilterModeButton } from "./styles";
import type { FilterModeButtonProps } from "./types";

export const FilterModeButton = ({ isSelected, label }: FilterModeButtonProps) => {
    return (
        <StyledFilterModeButton
            type={isSelected ? "outlined" : "flatDark"}
            label={label ?? translate("si.filter-panel.mode.manual.trigger.title")}
            width="100%"
            withPointerEvents={!isSelected}
        />
    );
};
